module.exports = __webpack_public_path__ + "media/assets/images/flags/it-bb6d292ea58ecdf47416d7557d9a63d4.svg";